/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../cms/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {RootState} from '../../setup'
import {MasterInit} from '../../cms/layout/MasterInit'
import Callback from '../modules/auth/Callback'

const Routes: FC = () => {
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  return (
    <>
      <Switch>
        {/*Password links arrive by email and must render even when someone is already
           signed in on this browser — the token in the url authorizes them, not the session.*/}
        <Route
          path={[
            '/auth/set-password/:id?',
            '/auth/reset-password/:id',
            '/auth/forgot-password',
            '/auth/success',
          ]}
        >
          <AuthPage />
        </Route>

        {!isAuthorized ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Route>
            <AuthPage />
          </Route>
        ) : (
          /*Otherwise redirect to root page (`/`)*/
          <Redirect from='/auth' to='/' />
          // <Redirect from='/sso' to='/' />
        )}

        <Route path='/error' component={ErrorsPage} />
        <Route path='/logout' component={Logout} />
        {/* <Route path='/signout-callback-oidc' component={Logout} /> */}

        {!isAuthorized ? (
          /*Redirect to `/auth` when user is not authorized*/
          // <Redirect to='/' />
          <Redirect to='/auth/login' />
        ) : (
          <>
            <MasterLayout>
              <PrivateRoutes />
            </MasterLayout>
          </>
        )}
      </Switch>
      <MasterInit />
    </>
  )
}

export {Routes}
